<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-shopping-bag-1"></i> 采购申请</span>
      </div>

      <!-- 搜索区域 -->
      <el-form
        :model="queryParams"
        label-position="right"
        label-width="80px"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20" type="flex" align="middle">
          <!-- 申请部门 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="申请部门">
              <el-select
                v-model="queryParams.departmentName"
                placeholder="请选择申请部门"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 申请人 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="申请人">
              <el-input
                v-model="queryParams.creatorName"
                placeholder="请输入申请人"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <!-- 状态 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="状态">
              <el-select
                v-model="queryParams.state"
                placeholder="请选择状态"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 按钮区域 -->
        <div>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
          >
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          <!-- <el-button @click="handleExport">导出</el-button> -->
        </div>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column
          prop="departmentName"
          label="申请部门"
          width="150"
          fixed
        ></el-table-column>
        <el-table-column
          prop="creatorName"
          label="申请人"
          width="120"
          fixed
        ></el-table-column>
        <el-table-column
          prop="requiredDate"
          label="需用日期"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="reason"
          label="申请事由"
          min-width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="totalPrice"
          label="采购总价"
          width="120"
        ></el-table-column>
        <el-table-column prop="state" label="状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="formatState(scope.row.state).type">
              {{ formatState(scope.row.state).text }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="level1Approver"
          label="主任"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="level2Approver"
          label="分管副园长"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="level3Approver"
          label="园长"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="levelCCApprover"
          label="抄送给"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="rejectReason"
          label="驳回信息"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="发起时间"
          width="160"
        ></el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click="handleExportById(scope.row.id)"
            >
              导出
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />
    </el-card>
  </div>
</template>

<script>
import {
  purchaseApplicationPage,
  purchaseApplicationExport,
} from "@/api/admin";
import { APPROVAL_STATUS_OPTIONS } from "@/utils/const.js";
import { formatState, downloadFile } from "@/utils/util";
import PaginationBar from "@/components/PaginationBar";
import { mapState } from "vuex";

export default {
  name: "PurchaseApproval",
  components: { PaginationBar },
  computed: {
    ...mapState(["departmentList"]), // 从 Vuex 获取 userPermissions
  },
  data() {
    return {
      statusOptions: APPROVAL_STATUS_OPTIONS,
      // departmentList: [],
      selectedRows: [],
      total: 100,
      pageSize: 10,
      currentPage: 1,

      // 查询参数
      queryParams: {
        name: "",
        department: "",
        status: "",
      },

      // 表格数据
      tableData: [],
    };
  },
  created() {
    this.handleQuery(1);
    // 请求所有的部门
  },
  methods: {
    formatState,
    handleQuery(page) {
      this.currentPage = page || 1;
      purchaseApplicationPage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = {
        name: "",
        department: "",
        status: "",
      };
      this.handleQuery(1);
    },
    handleExportById(id) {
      purchaseApplicationExport({ id }) // 将 id 作为参数传递
        .then((res) => {
          downloadFile(
            res.data,
            `采购申请_${id}.xlsx`,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          );
        })
        .catch(() => {
          this.$message.error("导出失败，请稍后重试");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  .el-table {
    .el-table__cell {
      white-space: nowrap;
    }
  }

  .el-tag {
    margin-right: 5px;
  }

  .el-button {
    margin-right: 5px;
  }

  .el-select {
    width: 100%;
  }

  .el-form-item__label {
    font-weight: bold;
    color: #333;
  }

  .el-form-item__content {
    .el-input,
    .el-select,
    .el-date-editor {
      width: 100%;
    }
  }
}
</style>
